import React from "react";
import useStyles from './styles';
import WarningIcon from '@material-ui/icons/Warning';

const UpdatePhoneMessage = ({message}) => {

    const classes = useStyles();

    return (

            <div className={classes.container} id={`div-update-phone-${message?.id}`} data-cy={`div-update-phone-${message?.id}`}>
                 <WarningIcon className={classes.icon} id={`update-phone-warning-icon-${message?.id}`} data-cy={`div-update-phone-warning-icon-${message?.id}`}/> {message?.body}
            </div>

    );
}

export default UpdatePhoneMessage;
